import { LandingPageCoordinatesTypename, WebInteractiveCoordinatesTypename } from 'personalization-lib/__generated__/chirp/com/hubspot/personalize/rpc/PersonalizeRpc';
export const ASSET_TYPES = {
  LANDING_PAGE: 'LANDING_PAGE',
  WEB_INTERACTIVE: 'WEB_INTERACTIVE'
};
export const SUPPORTED_ASSET_TYPES = [ASSET_TYPES.LANDING_PAGE, ASSET_TYPES.WEB_INTERACTIVE];
export const ASSET_TYPE_TO_COORDINATES = {
  [ASSET_TYPES.LANDING_PAGE]: LandingPageCoordinatesTypename,
  [ASSET_TYPES.WEB_INTERACTIVE]: WebInteractiveCoordinatesTypename
};